import { createRouter, createWebHashHistory } from 'vue-router'

import dayBookRouter from '@/modules/daybook/router'
import authRouter from '@/modules/auth/router'
import isAutheticatedGuard from '../modules/auth/router/auth-guard'
const routes = [
  {
    path: '/',
    name: 'Home',
    redirect: '/daybook'
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path: '/auth',
    ...authRouter
  },
  {
    path: '/daybook',
    beforeEnter: [ isAutheticatedGuard],
    ...dayBookRouter
  }

]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
